import React from 'react';
import PropTypes from 'prop-types';
import { serviceState } from '../../services/SandboxService';
import './sandbox.css';

const LABELS = {
  building: 'Building',
  running: 'Running',
  crashed: 'Crashed',
  failed: 'Build failed',
  stopped: 'Stopped',
  // A command-line tool once built (utils/cliServices.js): ready, never "running".
  built: 'Built',
};

/** A small pill with a service's state; restarts are added when there were any. */
export default function ServiceState({ service = null }) {
  const state = serviceState(service);
  const restarts = service?.restartCount || 0;
  const warn = state === 'running' && restarts > 0;
  return (
    <span className={`sbx-pill sbx-pill-${warn ? 'warn' : state}`}>
      {state === 'running' || state === 'building' ? <span aria-hidden="true" className="sbx-dot" /> : null}
      {LABELS[state]}
      {warn ? ` · ${restarts} restart${restarts === 1 ? '' : 's'}` : ''}
    </span>
  );
}

ServiceState.propTypes = { service: PropTypes.object };
